import styled from 'styled-components';
import StyledLink from 'components/StyledLink';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 24px;
  row-gap: 24px;
`;

export const MoreService = styled(StyledLink)`
  display: block;
  width: 100%;
  text-align: end;
`;
